import { IButtonStyles, IStyle } from '@fluentui/react';

import { IH2OTheme } from '../../models/components.models';
import { Sizes } from '../../themes/styles';
import { IButtonContainerStyles } from '../Button/Button.styles';

export interface ICodeBlockStyles {
  pre: IStyle;
  root: IStyle;
}

export const codeBlockStylesDefault = (theme: IH2OTheme): Partial<ICodeBlockStyles> => ({
  root: {
    position: 'relative',
    backgroundColor: theme.palette?.gray900,
  },
  pre: {
    fontFamily: 'monospace',
    padding: 24,
    backgroundColor: theme.palette?.gray900,
    color: theme.palette?.white,
    overflow: 'auto',
    position: 'relative',
    marginRight: 54,
  },
});

export const codeBlockButtonStyles = (theme: IH2OTheme): Partial<IButtonStyles> => ({
  root: {
    backgroundColor: theme.palette?.gray900,
    border: `1px solid ${theme.palette?.white}`,
    borderTopLeftRadius: Sizes.borderRadius,
    borderBottomLeftRadius: Sizes.borderRadius,
  },
  rootHovered: {
    backgroundColor: theme.palette?.gray800,
  },
  rootFocused: {
    backgroundColor: theme.palette?.gray800,
  },
  rootPressed: {
    backgroundColor: theme.palette?.gray800,
  },
  icon: {
    color: theme.palette?.white,
    margin: 0,
  },
  iconHovered: {
    color: theme.palette?.gray400,
  },
  iconPressed: {
    color: theme.palette?.gray400,
  },
});

export const codeBlockButtonContainerStyles: Partial<IButtonContainerStyles> = {
  root: {
    position: 'absolute',
    top: '16px',
    right: '12px',
    zIndex: 1,
  },
};
